export const FAILED = 'HistoryLog/failed';
export const LOADING = 'HistoryLog/loading';
export const SUCCESS = 'HistoryLog/success';
export const ACTION = 'HistoryLog/action';
export const RESET = 'HistoryLog/reset';
